import { Component, Input, OnInit } from '@angular/core';
import { ReclamacionesService } from '../../../services/reclamaciones.service';
import { IncidenciasService } from '../../../services/incidencias.service';

@Component({
  selector: 'app-ps-reclamaciones-incidencias',
  templateUrl: './ps-reclamaciones-incidencias.component.html',
  styleUrls: ['./ps-reclamaciones-incidencias.component.scss']
})
export class PsReclamacionesIncidenciasComponent implements OnInit {

  @Input() idPs: number
  reclamaciones: any;
  incidencias: any;
  hasIncidencias = false;
  hasReclamaciones = false;

  constructor(private _reclamacionService: ReclamacionesService, private _incidenciaService: IncidenciasService) { }

  ngOnInit() {
    this._reclamacionService.getReclamacionByPs(this.idPs).subscribe(x => {
      this.reclamaciones = x;
      if(this.reclamaciones.length > 0) {
        this.hasReclamaciones = true;
      }
    })
    this._incidenciaService.getIncidenciaByPs(this.idPs).subscribe(x => {
      this.incidencias = x
      if(this.incidencias.length > 0) {
        this.hasIncidencias = true;
      }
    })
  }

}
